import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useRegionalService } from 'hooks/useRegionalService'

import { Results } from './components'
import useRouter from 'utils/useRouter'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Regionais = (props) => {
  const { route } = props
  const router = useRouter()
  const classes = useStyles()
  const regionalService = useRegionalService()
  const idsState = useSelector((state) => state.idsState)

  const regionais = useSelector((state) => state.regionais.regionais)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    regionalService.listarRegionaisDeOrgaoGlobal(idsState.idOrgao)
   
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao}`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
        idPai={idsState.idOrgao}
      />
      {regionais && <Results className={classes.results} dados={regionais} />}
    </Page>
  )
}
